import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/ui/button';

interface LanguageSelectProps {
  languages: string[];
  loading: boolean;
  onSelect: (language: string) => void;
}

export function LanguageSelect({
  languages,
  loading,
  onSelect
}: LanguageSelectProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        <div className="rounded-2xl border border-border bg-card px-8 py-10 shadow-sm">
          <div className="mb-6 flex flex-col items-center gap-3">
            <div className="flex size-12 items-center justify-center rounded-full bg-primary/10">
              <Globe className="size-6 text-primary" />
            </div>
            <div className="text-center">
              <h1 className="text-xl">{t('screening.selectLanguage')}</h1>
              <p className="mt-1 text-sm text-muted-foreground">
                {t('screening.selectLanguageDescription')}
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            {languages.map((lang) => (
              <Button
                key={lang}
                variant="outline"
                className="h-12 w-full justify-start text-base"
                disabled={loading}
                onClick={() => {
                  onSelect(lang);
                }}
              >
                {t(`screening.languages.${lang}`, lang)}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
